import { render, staticRenderFns } from "./ThreadAuthor.vue?vue&type=template&id=30ab4073&scoped=true&"
import script from "./ThreadAuthor.vue?vue&type=script&lang=js&"
export * from "./ThreadAuthor.vue?vue&type=script&lang=js&"
import style0 from "./ThreadAuthor.vue?vue&type=style&index=0&id=30ab4073&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab4073",
  null
  
)

export default component.exports